/* unplugin-vue-components disabled */import { render } from "./relatedVideo.vue?vue&type=template&id=cf95e880&scoped=true&ts=true"
import script from "./relatedVideo.vue?vue&type=script&lang=ts"
export * from "./relatedVideo.vue?vue&type=script&lang=ts"

import "./relatedVideo.vue?vue&type=style&index=0&id=cf95e880&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf95e880"],['__file',"src/views/videoDetail/cpns/relatedVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf95e880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf95e880', __exports__)) {
    console.log('reload')
    api.reload('cf95e880', __exports__)
  }
  
  module.hot.accept("./relatedVideo.vue?vue&type=template&id=cf95e880&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('cf95e880', render)
  })

}


export default __exports__